import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

const ProfileSectionTitle = ({ hideBorder, className, ...rest }) => (
  <div
    className={classnames(
      className,
      'font-ownersWide text-white text-base mb-6 font-semibold md:text-xl',
      {
        'font-semibold border-dashed border-0 border-t-2 pt-8 border-opacity-20 border-white md:border-opacity-100 md:border-solid':
          !hideBorder,
      }
    )}
    {...rest}
  />
)

ProfileSectionTitle.propTypes = {
  hideBorder: PropTypes.bool,
}

export default ProfileSectionTitle
